import { Alert } from "react-bootstrap";

const AlertInvalidPolicy = ({ show }: { show: boolean }) => (
  <Alert show={show} variant="primary" className="mw--635 mx-auto">
    <i className="fal fa-info-circle alert__icon" />
    <div className="alert__text">
      Unfortunately, we cannot provide a policy from our online special event
      insurance program given the details provided. For more information, please
      call{" "}
      <a href="tel:+1-844-747-6240" className="text-nowrap font-weight-normal">
        (844) 747-6240
      </a>
    </div>
  </Alert>
);

export default AlertInvalidPolicy;
